// extracted by mini-css-extract-plugin
module.exports = {"table":"BorrowersTable_table__2dn9p","tableContainer":"BorrowersTable_tableContainer__2XXBM"};